<template>
	<div class="animate fadeIn w-100 py-4">
        <div class="w-100 text-center px-5 d-flex flex-wrap align-items-center ">
			<div class="w-100"> 
				  <i class="fas fa-check-circle fa-5x text-blue"></i>
					<h2 class="text-blue mt-0">Complete!</h2>
					<p>Thanks for your responses! We will be in touch shortly.</p>
					<div
						class="form-control col d-flex btn-blue align-items-center justify-content-center col-sm-4 col-6 mx-auto"
						@click="redoChat"
					>
						<i class="fas fa-redo mr-4"></i>
						Restart
					</div>
			</div>
        </div>

	</div>
</template>

<script>
	/**
	 *  Import dependencies & event bus
	 */
	import store from '../../store'
	import { mapState, mapActions } from 'vuex'
	import { EventBus } from '../../event-bus'
	import Cookies from 'js-cookie'
	import * as appConfigs from '../../configs'
	import axios from 'axios'
    import queryString from 'query-string'
	import { includes } from 'lodash'

	/**
	 * Import local components
	 */

    
    export default {
        props: [
            'data', 'messages'
        ],
		store,
	    components: {},
		mounted() {
            this.initializeReminderToken();
		},

		computed: {
			...mapState({
				configs: state => state.configs,
				orderId: state => state.orderId, // 3026
				pendingOrder: state => state.pendingOrder,
				selectedOccupation: state => state.selectedOccupation,
				step: state => state.step,
				prevStep: state => state.prevStep,
				unavailableOccupations: state => state.unavailableOccupations,
			}),


			
		},

        methods: {
            //check if reminder token exists, if it is then need to fire an ajax request to
            //check if the token is valid, then set the cookie, otherwise no further action
            //needed to be taken
            initializeReminderToken(){
                let vm = this
                let queryStringObj = queryString.parse(location.search)
                if('reminder_token' in queryStringObj)
                {
                    //if any error/exception occur, do not need to do anything, so axios do not need
                    //catch to handle error
                    axios.get(appConfigs.decryptReminderTokenUrl, {
                        params: queryStringObj
                    }).then((response) => {
                        if(response.data.status == 'error')
                        {
                            Cookies.remove('pendingOrderId')
                            vm.$store.commit('setError', { error: response.data.message })
                        }
                        else if(response.data.status == 'success')
                        {
					        Cookies.set('pendingOrderId', response.data.pending_order_id)
                        }

                    }).catch(error => {
						Cookies.remove('pendingOrderId')
                        vm.$store.commit('setError', { error: 'Invalid token error' })
                    })
                }
			},
			formatCurrency(value){
				var parts = value.toString().split(".");
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				value = "$" + parts.join(".");
				return value;
			},
			redoChat() {
				this.$emit("redoChat");
			}
        }
	}
</script>

<style>
.message_user{
    padding: 10px;
}
.text-blue{
    color: #1e98e0;
}
.btn-blue{
    background-color: #1e98e0;
	color: #fff;
	text-transform: uppercase;
	text-align: center;
	cursor:pointer;
	border: 1px solid #1e98e0;
}
.btn-blue:hover{
	background-color: #009245 !important;
	border: 1px solid #009245 !important;
	
}
.blue-line{
    background-color: #1e98e0;
    border-radius: 10px;
    height:8px;
}
.message-box_user{
    border: 2px solid #bce4f9;
    background-color: #bce4f9;
    padding: 10px;
    color: #000;
    margin-top:3px;
	border-radius: 15px 0px 15px 15px;
	width: fit-content;
	max-width: 60%;
	text-align: right;
	font-size: 16px;
	line-height: 26px;
}
@media screen and (max-width: 768px) {
 	.message_user{
		padding: 5px !important;
		max-width: 100%;
	}
	.message-box_user{
		max-width: 100%;
	}
}

</style>
    